import { useEffect, useState } from 'react'

import { deviceDetectReady, getDeviceDetect } from '../utils/device-detect'

// Reactive access to the lazily-loaded device-detect values: returns the
// current cache and re-renders the component once the chunk warms, so UI gated
// on isMobile / isIOS (download prompts, store links) corrects itself if it
// mounted during the brief pre-warm window.
const useDeviceDetect = () => {
  const [value, setValue] = useState(getDeviceDetect)

  useEffect(() => {
    let active = true
    void deviceDetectReady.then(() => {
      if (active) setValue(getDeviceDetect())
    })
    return () => {
      active = false
    }
  }, [])

  return value
}

export default useDeviceDetect
